/**
 * @module Toast
 * Generally, it should live in a separate package (e.g. @repo/toast) but it creates the following problems:
 * 1. Need of configuration for the package (it uses `zustand` and `react`).
 * 2. Need of creation of a new storybook for the package (probably, we need an ability to create one storybook for several packages).
 * FIXME: Move it to a separate package after solving the problems above.
 */

import { useToastStore } from './store/toastStore';
import { State, ToastTypes } from './store/types';

export const fireToast: State['fire'] = (...args) => {
  const fireToast = useToastStore.getState().fire;
  return fireToast(...args);
};

export { ToastTypes };
